import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

const moneyFormat = wNumb({
    decimals: '0',
    mark: '.',
    thousand: ',',
    prefix: '&pound; ',
});

const dimensionFormat = wNumb({
    decimals: '0',
    mark: '.',
    thousand: ',',
    suffix: 'mm'
});

const getData = (querySelector, dataAttr) => {
    let val = document.querySelector(querySelector).getAttribute(`data-${dataAttr}`);
    if( parseInt(val) == val ) {
        return parseInt(val);
    } else {
        return val;
    }
}

const maxPrice = getData('#artwork', 'maxprice');
const priceFrom = document.querySelector('[name=price-from]');
const priceTo = document.querySelector('[name=price-to]');

noUiSlider.create(document.querySelector('#price'), {
    start: [priceFrom.value, priceTo.value],
    connect: [ false, true, false ],
    tooltips: [ moneyFormat, moneyFormat ],
    step: 100,
    margin: 100,
    range: {
        'min': [ 0 ],
        'max': [ maxPrice + 100 ]
    }
}).on('update', values => {
    priceFrom.value = values[0];
    priceTo.value = values[1];
});

const maxDim = getData('#artwork', 'maxdim');
const sizeFrom = document.querySelector('[name=size-from]');
const sizeTo = document.querySelector('[name=size-to]');

noUiSlider.create(document.querySelector('#dimensions'), {
    start: [sizeFrom.value, sizeTo.value],
    connect: [ false, true, false ],
    tooltips: [ dimensionFormat, dimensionFormat ],
    step: 50,
    margin: 50,
    range: {
        'min': [ 0 ],
        'max': [ maxDim + 50 ]
    }
}).on('update', values => {
    sizeFrom.value = values[0];
    sizeTo.value = values[1];
});

const orderBy = document.querySelector('.direction');
const icon = document.querySelector('.order-icon');
const input = document.querySelector('[name=direction]');

orderBy.addEventListener('click', event => {
    event.preventDefault();

    if(input.value == 'ASC') {
        input.value = 'DESC';
        icon.innerHTML = 'arrow_downward';
    } else {
        input.value = 'ASC';
        icon.innerHTML = 'arrow_upward';
    }
})

// i have no idea why this doesn't work natively
const searchText = document.querySelector('[name=search]');
const form = document.querySelector('#search-form');

searchText.addEventListener('keyup', event => {
    if (event.keyCode == 13) {
        form.submit();
    }
})